module.exports = __webpack_public_path__ + "static/media/tipgoal-active.2bdfbae3.svg";